import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

const SUPABASE_URL = "https://ffrujifxswtyhgycfdci.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZmcnVqaWZ4c3d0eWhneWNmZGNpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA0NjI5MDAsImV4cCI6MjA3NjAzODkwMH0.pgX8e0Ng1osKGY2CWPzhcQzFVo6jDW2XOXvz6WsP3bo";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
